import type { ReactNode } from 'react';

import { cn } from '@/lib/utils';

interface TooltipHeaderProps {
  readonly icon: React.ComponentType<{ className?: string }>;
  readonly title: string;
  readonly subtitle?: ReactNode;
  readonly badges?: ReactNode;
  readonly titleClassName?: string;
  readonly iconClassName?: string;
  readonly className?: string;
}

export const TooltipHeader = ({
  icon: Icon,
  title,
  subtitle,
  badges,
  titleClassName,
  iconClassName,
  className,
}: TooltipHeaderProps) => {
  return (
    <div
      className={cn(
        'flex items-center gap-2.5 border-b border-gray-100 bg-white/95 px-3 py-2.5 backdrop-blur-sm',
        className,
      )}
    >
      <div className="flex h-5 w-5 shrink-0 items-center justify-center rounded-md bg-gray-100/80 shadow-sm ring-1 ring-gray-200">
        <Icon
          className={cn('h-3 w-3 text-gray-500', iconClassName)}
          aria-hidden="true"
        />
      </div>

      <div className="flex min-w-0 flex-1 items-baseline gap-2">
        <h3
          className={cn(
            'break-words text-sm font-semibold tracking-tight text-gray-900',
            titleClassName,
          )}
        >
          {title}
        </h3>
        {subtitle && (
          <span className="truncate text-[11px] font-medium text-gray-500">
            {subtitle}
          </span>
        )}
      </div>

      {badges && (
        <div className="flex shrink-0 items-center gap-1.5">{badges}</div>
      )}
    </div>
  );
};
